import React from 'react'
import { Link } from 'react-router-dom'

//import Namer from '../../components/namer'
import Logo from '../../../common/assets/logo.js'
import { META_TAGS } from '../../../common/constants'

export default () => {
	return (
		<React.Fragment>
		<div className="background" />
		<div className="canvas">
			<div className="canvas__track">
				<div className="u-width-wrap">
					{/* <Namer /> */}
					<div className="cta-container">
						<Logo />
						<h1 className="headline">Watch Skate Videos</h1>
						<ul className="value-props">
							<li className="value-prop value-prop--show">All your favorites. All in one place.</li>
							{/* <li className="value-prop">Full-length skate videos and parts.</li>
							<li className="value-prop">Classics and current skate videos.</li>
							<li className="value-prop">New skate videos added regularly.</li> */}
						</ul>
						<div className="cta-buttons">
							<Link className="cta-button cta-button--join" to="signup">Join For Free</Link>
							<Link className="cta-button cta-button--sign-in" to="login">Sign In</Link>
						</div>
						<p className="copyright">{META_TAGS.COPYRIGHT_STATEMENT}</p>
					</div>
				</div>
			</div>
		</div>
		</React.Fragment>
	)
}



// WEBPACK FOOTER //
// ./src/desktop/pages/home/index.js